
export const eData = {
    serviceId: 'service_85uibnk',
    templateId: 'template_1lbomd4',
    publicKey: 'zA1JGWUqh79TFaDA2'
};